import React, { createContext, useContext, useEffect, useState } from "react";

const STRINGS = {
  fr: {
    survey_teaser: "Une petite question avant de découvrir ce qu'il y a dans ta CAN'EAT 👀",
    validate: "VALIDER",
    choose_your: "Choisis ta CAN'EAT",
    choose_sub: "Des desserts gourmands, directement dans ta canette.",
    see_ingredients: "Voir les ingrédients",
    back_to_cans: "Retour aux CAN'EAT",
    ingredients_title: "Ingrédients",
    allergens_title: "Allergènes",
    allergens_contains: "Contient :",
    available: "Disponible",
    unavailable: "Indisponible",
    loading: "Chargement…",
    please_select: "Sélectionne une réponse",
    thanks_title: "Merci !",
    thanks_sub: "On t'emmène vers les CAN'EAT…",
    select_flavour: "Choisis ton goût",
    tagline: "DESSERT IN A CAN",
    no_products: "Aucun produit disponible pour le moment.",
    // admin
    admin_login_title: "Espace administrateur",
    admin_login_sub: "Connecte-toi pour gérer CAN'EAT",
    email: "Email",
    password: "Mot de passe",
    login: "Se connecter",
    logout: "Déconnexion",
    dashboard: "Tableau de bord",
    tab_products: "Produits",
    tab_survey: "Sondage",
    tab_stats: "Statistiques",
    tab_machines: "Distributeurs",
    nutrition_title: "Valeurs nutritionnelles",
    nutrition_none: "Informations nutritionnelles bientôt disponibles.",
    composition_title: "Composition",
  },
  nl: {
    survey_teaser: "Een kleine vraag voordat je ontdekt wat er in jouw CAN'EAT zit 👀",
    validate: "BEVESTIGEN",
    choose_your: "Kies jouw CAN'EAT",
    choose_sub: "Heerlijke desserts, rechtstreeks in je blikje.",
    see_ingredients: "Bekijk de ingrediënten",
    back_to_cans: "Terug naar de CAN'EAT",
    ingredients_title: "Ingrediënten",
    allergens_title: "Allergenen",
    allergens_contains: "Bevat:",
    available: "Beschikbaar",
    unavailable: "Niet beschikbaar",
    loading: "Laden…",
    please_select: "Kies een antwoord",
    thanks_title: "Bedankt!",
    thanks_sub: "We brengen je naar de CAN'EAT…",
    select_flavour: "Kies je smaak",
    tagline: "DESSERT IN A CAN",
    no_products: "Momenteel geen producten beschikbaar.",
    admin_login_title: "Beheerdersruimte",
    admin_login_sub: "Log in om CAN'EAT te beheren",
    email: "Email",
    password: "Wachtwoord",
    login: "Inloggen",
    logout: "Uitloggen",
    dashboard: "Dashboard",
    tab_products: "Producten",
    tab_survey: "Enquête",
    tab_stats: "Statistieken",
    tab_machines: "Automaten",
    nutrition_title: "Voedingswaarden",
    nutrition_none: "Voedingsinformatie binnenkort beschikbaar.",
    composition_title: "Samenstelling",
  },
  en: {
    survey_teaser: "One quick question before you discover what's inside your CAN'EAT 👀",
    validate: "SUBMIT",
    choose_your: "Choose your CAN'EAT",
    choose_sub: "Indulgent desserts, straight in a can.",
    see_ingredients: "See the ingredients",
    back_to_cans: "Back to the CAN'EAT",
    ingredients_title: "Ingredients",
    allergens_title: "Allergens",
    allergens_contains: "Contains:",
    available: "Available",
    unavailable: "Unavailable",
    loading: "Loading…",
    please_select: "Please select an answer",
    thanks_title: "Thank you!",
    thanks_sub: "Taking you to the CAN'EAT…",
    select_flavour: "Choose your flavour",
    tagline: "DESSERT IN A CAN",
    no_products: "No products available right now.",
    admin_login_title: "Admin area",
    admin_login_sub: "Sign in to manage CAN'EAT",
    email: "Email",
    password: "Password",
    login: "Sign in",
    logout: "Log out",
    dashboard: "Dashboard",
    tab_products: "Products",
    tab_survey: "Survey",
    tab_stats: "Statistics",
    tab_machines: "Machines",
    nutrition_title: "Nutrition facts",
    nutrition_none: "Nutritional information coming soon.",
    composition_title: "Composition",
  },
};

export const NUTRITION_FIELDS = [
  { key: "portion", fr: "Portion", nl: "Portie", en: "Serving", unit: "" },
  { key: "energy_kj", fr: "Énergie (kJ)", nl: "Energie (kJ)", en: "Energy (kJ)", unit: "kJ" },
  { key: "energy_kcal", fr: "Énergie (kcal)", nl: "Energie (kcal)", en: "Energy (kcal)", unit: "kcal" },
  { key: "fat", fr: "Matières grasses", nl: "Vetten", en: "Fat", unit: "g" },
  { key: "saturates", fr: "dont acides gras saturés", nl: "waarvan verzadigde vetzuren", en: "of which saturates", unit: "g" },
  { key: "carbohydrate", fr: "Glucides", nl: "Koolhydraten", en: "Carbohydrate", unit: "g" },
  { key: "sugars", fr: "dont sucres", nl: "waarvan suikers", en: "of which sugars", unit: "g" },
  { key: "fibre", fr: "Fibres", nl: "Vezels", en: "Fibre", unit: "g" },
  { key: "protein", fr: "Protéines", nl: "Eiwitten", en: "Protein", unit: "g" },
  { key: "salt", fr: "Sel", nl: "Zout", en: "Salt", unit: "g" },
];

export const ALLERGENS = {
  gluten: { fr: "Gluten", nl: "Gluten", en: "Gluten", icon: "Wheat" },
  lait: { fr: "Lait", nl: "Melk", en: "Milk", icon: "Milk" },
  oeufs: { fr: "Œufs", nl: "Eieren", en: "Eggs", icon: "Egg" },
  soja: { fr: "Soja", nl: "Soja", en: "Soy", icon: "Bean" },
  fruits_a_coque: { fr: "Fruits à coque", nl: "Noten", en: "Nuts", icon: "Nut" },
};

export const LANGUAGES = [
  { code: "fr", label: "FR" },
  { code: "nl", label: "NL" },
  { code: "en", label: "EN" },
];

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("caneat_lang") || "fr");
  useEffect(() => { localStorage.setItem("caneat_lang", lang); }, [lang]);
  const t = (key) => (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.fr[key] || key;
  const tl = (obj) => {
    if (!obj) return "";
    return obj[lang] || obj.fr || Object.values(obj)[0] || "";
  };
  return (
    <LangContext.Provider value={{ lang, setLang, t, tl }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
